export default "__VITE_ASSET__BxvcKjP9__"